import { Routes } from '@angular/router';
import { FAQComponent } from './faq.component';

export const ModuleRoutes: Routes = [
    {
        path: '',
        component: FAQComponent
    }
]
